import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx } from "vue"

import { computed, ref, watch, withDefaults } from "vue";
import { ArtifactTypeInputProps } from "@/types";
import { artifactStore, timStore, useVModel } from "@/hooks";
import { AttributeChip, Typography } from "@/components/common/display";


/**
 * An input for selecting artifact types.
 */
const __default__ = {
  name: "ArtifactTypeInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    showCount: { type: Boolean },
    dense: { type: Boolean },
    multiple: { type: Boolean, default: false },
    label: { default: "Artifact Types" },
    errorMessage: { type: [String, Boolean], default: undefined },
    hint: { default: undefined }
  },
  emits: ["update:modelValue", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const model = useVModel(props, "modelValue");

const options = ref(timStore.typeNames);

const optionCount = computed(() =>
  props.showCount && typeof model.value === "string"
    ? artifactStore.artifactsByType.get(model.value)?.length || 0
    : 0
);

const optionCountDisplay = computed(() =>
  optionCount.value === 1 ? "1 Artifact" : `${optionCount.value} Artifacts`
);

/**
 * Filters the artifact type options.
 * @param searchText - The search text to filter with.
 * @param update - A function call to update the options.
 */
function filter(
  searchText: string | null,
  update: (fn: () => void) => void
): void {
  update(() => {
    if (!searchText) {
      options.value = timStore.typeNames;
    } else {
      const lowercaseSearchText = searchText.toLowerCase();

      options.value = timStore.typeNames.filter((type) =>
        (type?.toLowerCase() || "").includes(lowercaseSearchText)
      );
    }
  });
}

watch(
  () => timStore.typeNames,
  (typeNames) => (options.value = typeNames)
);

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    ref: "artifactTypeInput",
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    filled: "",
    label: _ctx.label,
    multiple: _ctx.multiple,
    options: options.value,
    hint: _ctx.hint,
    "error-message": _ctx.errorMessage || undefined,
    dense: props.dense,
    "use-input": "",
    "new-value-mode": "add-unique",
    "input-debounce": "0",
    onFilter: filter,
    onPopupHide: _cache[1] || (_cache[1] = ($event: any) => (emit('blur')))
  }, {
    "selected-item": _withCtx(({ opt }) => [
      (!!opt)
        ? (_openBlock(), _createBlock(_unref(AttributeChip), {
            key: 0,
            "artifact-type": "",
            value: opt,
            dense: props.dense
          }, null, 8, ["value", "dense"]))
        : _createCommentVNode("", true),
      (optionCount.value > 0)
        ? (_openBlock(), _createBlock(_unref(Typography), {
            key: 1,
            l: "1",
            value: optionCountDisplay.value
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "label", "multiple", "options", "hint", "error-message", "dense"]))
}
}

})